import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";

function App() {
    return (
        <div className="App bg-ink text-white min-h-screen">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0C0F1A",
                        border: "1px solid rgba(212,175,55,0.3)",
                        color: "#fff",
                    },
                }}
            />
        </div>
    );
}

export default App;
